<template>
  <div>
    <div class="mb-4">
      <div class="title">
        {{ $l('title_estimate_setting') || '产能参数设置' }}
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        label-position="top"
        size="mini"
      >
        <el-row :gutter="10" class="mt-2">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_product_quantity') || '总成品数量'"
              prop="totPlanUnitQty"
            >
              <InputFormat :disabled="true" v-model="formData.totPlanUnitQty" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="
                $l('form_label_semi_product_quantity') || '半成品成套数量'
              "
              prop="unitSpecQty"
            >
              <InputFormat :disabled="true" v-model="formData.unitSpecQty" />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="
                $l('form_label_total_semi_product_quantity') || '总半成品数量'
              "
              prop="totPlanSpecQty"
            >
              <InputFormat :disabled="true" v-model="formData.totPlanSpecQty" />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="
                $l('form_label_package_capacity') || '包装日产能（人/天）'
              "
              prop="packingPerDay"
            >
              <InputFormat
                :disabled="disabled"
                v-model="formData.packingPerDay"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_people_of_day') || '每日包装人数'"
              prop="packersPerDay"
            >
              <InputFormat
                :disabled="disabled"
                v-model="formData.packersPerDay"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_capacity_of_day') || '包装日产能'"
              prop="dailyPackingQty"
            >
              <el-input readonly v-model="dailyPackingQty" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_daily_semi_of_day') || '半成品日产能'"
              prop="dailySpecQty"
            >
              <InputFormat
                :disabled="disabled"
                v-model="formData.dailySpecQty"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="
                $l('form_label_delivery_period') || '半成品运输周期（天）'
              "
              prop="transitTimes"
            >
              <InputFormat
                :disabled="disabled"
                v-model="formData.transitTimes"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_production_date') || '计划投产日期'"
              prop="productionDate"
            >
              <el-date-picker
                v-model="formData.productionDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_days_per_batch_cycle') || '每批次周期天数'"
              prop="perBatchDays"
            >
              <InputFormat
                :disabled="disabled"
                v-model="formData.perBatchDays"
              />
            </el-form-item>
          </el-col>

          <el-col :span="4">
            <el-form-item
              :label="
                $l('form_label_days_production_end_date') || '计划结束日期'
              "
              prop="productionEndDate"
            >
              <el-date-picker
                v-model="formData.productionEndDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                :placeholder="
                  $l('select_production_end_date') || '计划结束日期'
                "
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="4" v-if="!disabled">
            <el-row :gutter="10">
              <el-col :span="12">
                <div style="margin-top: 28px;">
                  <el-button
                    size="mini"
                    type="warning"
                    style="width: 100%;"
                    @click="openCessationDateSetting"
                    >{{
                      $l('btn_cessation_date_setting') || '设置停产日期'
                    }}</el-button
                  >
                </div>
              </el-col>
              <el-col :span="12">
                <div style="margin-top: 28px;">
                  <el-button
                    size="mini"
                    type="primary"
                    style="width: 100%;"
                    @click="genCapacityPlanning"
                    >{{
                      $l('btn_gen_capacity_planning') || '生成产能计划'
                    }}</el-button
                  >
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="mb-4">
      <ProductionBatches
        :evgPlanOrderCode="evgPlanOrderCode"
        :data="plan.batchList"
        :disabled="disabled"
      ></ProductionBatches>
    </div>
    <div class="mb-4">
      <DeliveryCalculation
        :evgPlanOrderCode="evgPlanOrderCode"
        :data="plan.matchList"
        :disabled="disabled"
      ></DeliveryCalculation>
    </div>
    <CessationDateSetting
      @confirm="onCessationSettingConfirm"
      :visible.sync="cessationSettingOption.visible"
      :type="cessationSettingOption.type"
      :productionCessationDate="cessationSettingOption.productionCessationDate"
      :productionEndDate="cessationSettingOption.productionEndDate"
      :productionDate="cessationSettingOption.productionDate"
    ></CessationDateSetting>
  </div>
</template>
<script>
import InputFormat from './input-format'
import DeliveryCalculation from './delivery-calculation'
import ProductionBatches from './production-batches'
import CessationDateSetting from './cessation-date-setting'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import { multiply } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    evgPlanOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  components: {
    InputFormat,
    DeliveryCalculation,
    ProductionBatches,
    CessationDateSetting,
  },
  data() {
    return {
      formData: {},
      plan: {},
      rules: {
        packingPerDay: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: this.$l('tips_must_be_greater_than_0') || '值须大于0',
          },
        ],
        packersPerDay: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: this.$l('tips_must_be_greater_than_0') || '值须大于0',
          },
        ],
        dailySpecQty: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: this.$l('tips_must_be_greater_than_0') || '值须大于0',
          },
        ],
        transitTimes: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: this.$l('tips_must_be_greater_than_0') || '值须大于0',
          },
        ],
        productionDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
        productionEndDate: [
          {
            required: true,
            message:
              this.$l('rules_production_end_date') || '请输入计划结束日期',
            trigger: 'blur',
          },
        ],
        perBatchDays: [
          {
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message: this.$l('tips_must_be_greater_than_0') || '值须大于0',
          },
        ],
      },
      cessationSettingOption: {
        visible: false,
        productionCessationDate: '[]',
        productionEndDate: '',
        productionDate: '',
        type: 'edit',
      },
    }
  },
  computed: {
    dailyPackingQty() {
      return multiply(
        this.formData.packingPerDay || 0,
        this.formData.packersPerDay || 0
      )
    },
  },
  created() {
    this.getData()
    this.$eventBus.$on('evg-planproduction-reload', (data) => {
      this.formData = data.plan
      this.plan = data
    })
  },
  methods: {
    getData() {
      this.loadingOpen()
      this.$api
        .ecomEvgPlanProductionDetailApi({
          evgPlanOrderCode: this.evgPlanOrderCode,
        })
        .then((res) => {
          this.loadingClose()

          const { status, msg, body } = res
          if (status !== 200) {
            this.$message.error(`查询产能计划错误: ${msg}`)
            return
          }

          this.formData = body.plan || {}
          this.plan = body
        })
        .catch(() => this.loadingClose())
    },
    async genCapacityPlanning() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.loadingOpen()
      this.$api
        .evgPlanProductionSaveAndGenerateApi({
          ...this.formData,
          evgPlanOrderCode: this.evgPlanOrderCode,
          dailyPackingQty: this.dailyPackingQty,
        })
        .then((res) => {
          this.loadingClose()

          const { status, msg, body } = res
          if (status !== 200) {
            this.$message.error(`生成产能计划失败: ${msg}`)
            return
          }

          this.formData = body.plan
          this.plan = body
        })
        .catch(() => this.loadingClose())
    },
    openCessationDateSetting() {
      this.cessationSettingOption.productionCessationDate =
        this.formData.productionCessationDate || '[]'
      this.cessationSettingOption.productionDate = this.formData.productionDate
      this.cessationSettingOption.productionEndDate = this.formData.productionEndDate
      this.cessationSettingOption.visible = true
    },
    onCessationSettingConfirm(productionCessationDate) {
      this.formData.productionCessationDate = JSON.stringify(
        productionCessationDate || []
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  height: 25px;
  line-height: 25px;
  color: #2b3447;
  font-size: 18px;
  font-weight: 600;
}
</style>
